import React from 'react'
import { Outlet } from 'react-router-dom'
import { SiteParent } from '@components/layout/SiteParent'

export interface MainLayoutProps {
  themeSwitcher?: boolean
  promoHeader?: boolean
}

/**
 * Main layout component that wraps the content with the site parent
 * Uses React Router's Outlet component to render nested routes
 */
export const MainLayout: React.FC<MainLayoutProps> = ({ themeSwitcher = false, promoHeader = false }) => (
  <SiteParent
    themeSwitcher={themeSwitcher}
    promoHeader={promoHeader}>
    <Outlet />
  </SiteParent>
)
